<app-navbar></app-navbar>
<div class="otp-page-wrapper">
  <div class="otp-page-background"></div>
  <div class="otp-page-content container">
    <div class="justify-content-center row">
      <div class="col-lg-5">
        <div class="otp-card">
          <div class="card-header bg-white">
            <div class="otp-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
          </div>
          <div class="card-body px-lg-5 py-lg-4">
            <div class="text-center text-login">
              <div class="text-login_welcome">
                رمز التفعيل
              </div>
              <div class="text-login_desc">
                تم إرسال رمز التفعيل إلى رقم هاتفك
              </div>
            </div>

            <div class="text-center phone-number">
              <span class="phone-number_text" dir="ltr">
                {{ phoneNumber }}
              </span>
            </div>

            <form class="otp-form" role="form">
              <div class="otp-inputs" dir="ltr">
                <input
                  *ngFor="let i of [0,1,2,3,4,5]"
                  #otpInput
                  type="text"
                  inputmode="numeric"
                  pattern="\d*"
                  maxlength="1"
                  class="otp-digit"
                  [class.filled]="digits[i]"
                  [value]="digits[i] || ''"
                  (input)="onDigitInput($event, i)"
                  (keydown)="onDigitKeydown($event, i)"
                  (paste)="onPaste($event)"
                />
              </div>

              <div class="timer-section text-center">
                <div class="timer-badge" *ngIf="timeLeft > 0">
                  <span class="timer-text">{{ formatTime(timeLeft) }}</span>
                </div>
                <a
                  *ngIf="canResend"
                  class="resend-link"
                  (click)="resendOtp()"
                >
                  إعادة إرسال الرمز
                </a>
                <p class="timer-hint" *ngIf="!canResend">
                  يمكنك إعادة إرسال الرمز بعد انتهاء المؤقت
                </p>
              </div>

              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-primary otp-submit-btn"
                  (click)="login()"
                  [disabled]="!isValid"
                >
                  تأكيد
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
